// Module generated from Markdown by Markdown Component Loader v1.1.0
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

MarkdownComponent.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object
};

function MarkdownComponent(props) {
  const { className, style } = props;

  return (
    <div className={className} style={style}>
      <h2 id="use-this-api-to-stay-up-to-date-on-va-forms.">Use this API to stay up-to-date on VA forms.</h2>
      <p>This API uses open data to make it easier to keep up with the ever-changing landscape of VA forms. This API indexes data sourced from <a href="https://www.va.gov/vaforms/search_action.asp">VA.gov</a>, creating unique hashes for each version of a form and allowing quick lookup. <Link to="/release-notes/vaForms">Review the latest release notes</Link>.</p>
    </div>
  );
};

export default MarkdownComponent;
